<script setup>
  import { getCurrentInstance, h, nextTick, onBeforeUnmount, onMounted, onUpdated, ref, render } from 'vue'
  import WishlistAddButton from '@/components/Wishlist/AddButton.vue'

  defineProps({
    item: Object
  })

  const itemElement = ref(null)
  const mountedWishlistButtons = new Set()
  const appContext = getCurrentInstance()?.appContext

  const mountWishlistButtons = async () => {
    await nextTick()

    if (!itemElement.value || !appContext) {
      return
    }

    const currentButtons = new Set(itemElement.value.querySelectorAll('wishlist-add-button'))

    mountedWishlistButtons.forEach((button) => {
      if (currentButtons.has(button)) {
        return
      }

      render(null, button)
      mountedWishlistButtons.delete(button)
    })

    currentButtons.forEach((button) => {
      if (mountedWishlistButtons.has(button)) {
        return
      }

      const nodeId = button.getAttribute('node-id')

      if (!nodeId) {
        return
      }

      const wishlistButton = h(WishlistAddButton, {
        nodeId
      })

      wishlistButton.appContext = appContext
      render(wishlistButton, button)
      mountedWishlistButtons.add(button)
    })
  }

  onMounted(() => {
    mountWishlistButtons()
  })

  onUpdated(() => {
    mountWishlistButtons()
  })

  onBeforeUnmount(() => {
    mountedWishlistButtons.forEach((button) => {
      render(null, button)
    })

    mountedWishlistButtons.clear()
  })
</script>

<template>
  <div
    :id="item.id"
    ref="itemElement"
    v-html="item.output"
  />
</template>

<style lang="scss" scoped>

</style>
